
import { Link } from "react-router-dom";
import { 
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";

export const WindowTypesDropdown = () => {
  return (
    <NavigationMenu>
      <NavigationMenuList>
        <NavigationMenuItem>
          <NavigationMenuTrigger className="font-inter text-secondary-dark hover:text-primary transition-colors bg-transparent hover:bg-transparent">
            Window Types
          </NavigationMenuTrigger>
          <NavigationMenuContent>
            <ul className="grid w-[400px] gap-3 p-4 md:w-[500px] md:grid-cols-2">
              <li className="row-span-3">
                <NavigationMenuLink asChild>
                  <Link to="/fixed-units-glazing" className="block select-none space-y-1 rounded-md bg-gradient-to-b from-accent/50 to-accent p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground">
                    <div className="text-lg font-medium text-white">Fixed Units</div>
                    <p className="line-clamp-2 text-sm leading-snug text-white opacity-90">
                      Non-opening glazing for maximum insulation and noise reduction.
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link to="/sliding-units-glazing" className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground">
                    <div className="text-sm font-medium leading-none">Sliding Units</div>
                    <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                      Easy access with horizontal or vertical sliding panels.
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link to="/hinged-units-glazing" className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground">
                    <div className="text-sm font-medium leading-none">Hinged Units</div>
                    <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                      Side or top hinged opening for full access.
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link to="/lift-out-units-glazing" className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground">
                    <div className="text-sm font-medium leading-none">Lift Out Units</div>
                    <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                      Completely removable panels for full window access.
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link to="/vertical-sliding-units-glazing" className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground">
                    <div className="text-sm font-medium leading-none">Vertical Sliding</div>
                    <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                      Traditional sash window style operation.
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link to="/horizontal-sliding-units-glazing" className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground">
                    <div className="text-sm font-medium leading-none">Horizontal Sliding</div>
                    <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                      Side-to-side sliding for space-efficient access.
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
};
